import React from "react";

import {
    Image,
    Platform,
    Text,
    TouchableOpacity,
    TouchableOpacityProps,
    View
} from "react-native";
import Activity from "../../../models/Activity";
import Images from "../../../../specific/utils/Images";
import AppTheme from "../../../utils/Theme";
import { getLanguage } from "../../../utils/Localization/Localization";
import User from "../../../data/user/User";
import { getMenuConfiguration, LEVEL_CONF } from "../../Menu/MenuConf";

interface ActivityLabelButtonProps extends TouchableOpacityProps {
    activity: Activity;
}

const ActivityLabelButton = (props: ActivityLabelButtonProps) => {

    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();
    const user: User = User.getInstance();
    const levelConfiguration: LEVEL_CONF = getMenuConfiguration(user.children_level);

    const { activity, ...restProps } = props;

    const refWidth = Platform.OS === "web" ? appTheme.getBlockWidth() : appTheme.getFullAppWidth();
    let cellSize = (refWidth - appTheme.pixelPerfect(60)) / 3;
    let imageSize = appTheme.pixelPerfect(70);
    if (imageSize > (cellSize - appTheme.pixelPerfect(10))) {
        imageSize = cellSize - appTheme.pixelPerfect(10);
    }

    // On va chercher l'image de la première activité de la catégorie
    let activityImage: number | { uri: string } | undefined = undefined;
    if ((activity.img_url !== undefined) && (activity.img_url.length > 0)) {
        activityImage = { uri: activity.img_url };
    }
    if ((activity.app_image !== undefined) && (activity.app_image.length > 0) && (images[activity.app_image] !== undefined)) {
        activityImage = images[activity.app_image];
    }
    const cellPadding: number = appTheme.pixelPerfect(5);
    const innerRadius: number = user.children_level === "cycle3" ? appTheme.pixelPerfect(10) : appTheme.pixelPerfect(20);
    const outerRadius: number = user.children_level === "cycle3" ? levelConfiguration.borderRadius + 2 : innerRadius + cellPadding;
    return <TouchableOpacity key={activity.key} style={{ marginHorizontal:appTheme.pixelPerfect(10), width: cellSize, height: appTheme.pixelPerfect(80), alignItems: "center", justifyContent: "center", flexDirection:"row", backgroundColor:"#FFFFFF", paddingHorizontal:cellPadding, borderRadius:outerRadius }} {...restProps}>
        <Image source={activityImage} style={{ width: imageSize, height: imageSize, borderRadius: innerRadius }} resizeMode="cover" />
        <View style={{ justifyContent: "flex-start", flex: 1, paddingHorizontal:2 }}>
            <Text numberOfLines={3} style={{ fontFamily: appTheme.primarySemiBoldFont, color: appTheme.darkBlue, textAlign: "center", fontSize: appTheme.pixelPerfectForFont(8) }}>{activity.title[getLanguage()]}</Text>
        </View>
    </TouchableOpacity>

}

export default ActivityLabelButton;

